import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Comparison } from './components/Comparison';
import { HowItWorks } from './components/HowItWorks';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
// import { VerifiedClosures } from './components/VerifiedClosures'
// import { Testimonials } from './components/Testimonials'
import { FAQ } from './components/FAQ';
import { WaitlistForm } from './components/WaitlistForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Comparison data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <Countdown data-id="element-5" />
      <Pricing data-id="element-6" />
      {/* <VerifiedClosures /> */}
      {/* <Testimonials /> */}
      <FAQ data-id="element-7" />
      <WaitlistForm data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}